module.exports = __webpack_public_path__ + "img/9788952213259.60022f97.jpg";